import { useRef } from "react"

import HeaderSearch from "./components/HeaderSearch"
import "./style.scss";
import { PrescriptiopnGlobalContext } from "../../../contexts/epicrisis/prescriptionContext";
import EpicrisisComponent from "../../../components/hb/epicrisis";

const Epicrisis = () => {
    const ref = useRef(null)
    return (
        <PrescriptiopnGlobalContext>
            <div className="d-flex help-page" ref={ref}>
                <EpicrisisComponent />
            </div>
        </PrescriptiopnGlobalContext>
    )
}

export default Epicrisis